import { createCommentVNode, createElementBlock, defineComponent, guardReactiveProps, normalizeProps, openBlock, renderSlot, unref } from "vue";
import { useBindCx } from "@scalar/use-hooks/useBindCx";
//#region src/components/ViewLayout/ViewLayoutSection.vue?vue&type=script&setup=true&lang.ts
var _hoisted_1 = {
	key: 0,
	class: "request-response-header bg-b-1 -mb-1/2 sticky top-0 z-1 flex min-h-11 items-center border-b px-2.5 text-base font-medium xl:rounded-none"
};
var ViewLayoutSection_vue_vue_type_script_setup_true_lang_default = /*@__PURE__*/ defineComponent({
	inheritAttrs: false,
	__name: "ViewLayoutSection",
	setup(__props) {
		const { cx } = useBindCx();
		return (_ctx, _cache) => {
			return openBlock(), createElementBlock("section", normalizeProps(guardReactiveProps(unref(cx)("xl:custom-scroll bg-b-1 flex flex-1 flex-col xl:h-full xl:min-w-0"))), [_ctx.$slots.title ? (openBlock(), createElementBlock("div", _hoisted_1, [renderSlot(_ctx.$slots, "title")])) : createCommentVNode("", true), renderSlot(_ctx.$slots, "default")], 16);
		};
	}
});
//#endregion
export { ViewLayoutSection_vue_vue_type_script_setup_true_lang_default as default };

//# sourceMappingURL=ViewLayoutSection.vue.script.js.map